import React, { Component } from 'react'
import { Header, Icon , Button, Divider, Modal} from 'semantic-ui-react'
import LicenseAccessForm from './LicenseAccessForm'

export default class LicenseAccessEdit extends Component {
    constructor(props) {
        super(props)
    }

    componentWillMount() {
        this.setState({
            open : false,
            canSave : false
        });
    }

    onClose = () => {
        this.setState(
            { open: false }
        )
    }

    onOpen = () => {
        this.setState(
            { open: true }
        )
    }

    onClick = ()  => {
        this.refs.licenseAccessForm.submit(this.props.onSubmit) // Submit form values
        this.setState(
            { open: false }
        )
    }


    onSave = (values) => {
        this.props.updateLicense({
            id: this.props.rowId,
            email: values.email_user,
            expire_date: values.expire_date,
            license_type: [values.license_type],
            num_licenses: values.num_licenses

        })

   }


    updateValidationBtnState = (canSave) => {
        this.setState({
            canSave: canSave
        })
    };

    render() {
        const {userId, data} = this.props;
        const {open, canSave} = this.state;


        return (
            <Modal size='small' open={open} dimmer='inverted'
                   trigger={<Icon name='write' size='large' onClick={this.onOpen}/>} >
                <Modal.Header>
                    <Header as='h4'>
                        <Icon.Group size='large'>
                            <Icon name='user'/>
                            <Icon corner name='write'/>
                        </Icon.Group>
                        Update license data for {userId}
                    </Header>
                </Modal.Header>
                <Modal.Content>
                    <LicenseAccessForm ref='licenseAccessForm' onSubmit={this.onSave.bind(this)} initialEmail={userId}
                                       disabledEmail={true}
                                       onUpdateValidationState={this.updateValidationBtnState} initialValues={data} emails={this.props.emails}/>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.onClick.bind(this)} disabled={canSave}>
                        <Icon name='write'/>Update license
                    </Button>
                    <Button onClick={() => {this.onClose()}}>
                        <Icon name='user cancel' />Cancel
                    </Button>
                </Modal.Actions>
            </Modal>
        )
    }
}


